import { render, staticRenderFns } from "./DxEmployeeEfectiveness.vue?vue&type=template&id=ace4adc8&"
import script from "./DxEmployeeEfectiveness.vue?vue&type=script&lang=js&"
export * from "./DxEmployeeEfectiveness.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports